import { useQuery } from 'react-query';
import { useEffect, useState } from 'react';
import {
  CAMPAIGNS_KEY,
  getCampaignTypes,
} from '../../../../../../api/services/mediaPlanning/campaigns';
import usePlanStore from '../../../../../../store/planStore';
import prepareSelectData from '../utils/prepareSelectData';
import { useError } from '../../../common/Errors/ErrorContext/ErrorContext';

const useCampaignScenario = (country: string) => {
  const {
    generalInfoState,
    selectedCountryISOCode,
    countryForms,
    selectedCountry,
    setSelectedCountryISOCode,
  } = usePlanStore();

  const { showError } = useError();

  const [isoCode, setIsoCode] = useState<string | null>(selectedCountryISOCode);

  useEffect(() => {
    if (country) {
      setSelectedCountryISOCode(country);
    }
  }, [country, setSelectedCountryISOCode]);

  useEffect(() => {
    setIsoCode(selectedCountryISOCode);
  }, [selectedCountryISOCode]);

  const { data: response, isFetching } = useQuery({
    queryKey: [
      CAMPAIGNS_KEY,
      'campaign-types',
      country,
      isoCode,
      countryForms[selectedCountry!]?.targetGroup,
    ],
    queryFn: () =>
      getCampaignTypes(generalInfoState.division, isoCode as string),
    enabled:
      !!isoCode &&
      !!generalInfoState.division &&
      !!countryForms[country]?.targetGroup,
    onError: (error: any) => {
      const errorMessage =
        error?.response?.data?.message || error.message || 'Unknown error';
      showError(errorMessage);
    },
  });

  const campaignScenarios = response?.data?.campaignScenarios || [];
  const preparedData = prepareSelectData(campaignScenarios);

  return { data: preparedData, isFetching };
};

export default useCampaignScenario;
